
export const useMapParamsToUrlPattern = () => {
    return (url: string, data: Record<string, string>) => {
        return Object.keys(data).reduce((acc, key) => {
            return acc.replace(`:${key}`, data[key] || '')
        }, url)
    }
}
